const appConfig = window.appConfig || {};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // Отладка выключена по умолчанию и включается ЯВНО — ключом `debug: true`
  // в `public/config.js`, где его видит тот, кто читает конфигурацию площадки.
  // До 08.09.2026 было наоборот: умолчание `true`, ключа в конфигурации нет,
  // и площадка работала с отладкой, которую для неё никто не выбирал (T049).
  debug: false,
  tokenStorageName: "DMAccessToken",
  credentialsTokenStorage: "DMCredentialToken",
  credentialsRefreshTokenStorage: "DMCredentialsRefreshToken",
  tokenExpireGapMin: 20,
  tokenCheckInterval: 1000 * 60 * 5,
  apiCheckInterval: 5000,
  clientSecret: process.env.OAUTH2_CLIENT_SECRET,
  ...appConfig,
};
